<div class="user-profile-container safe-area-inset-top safe-area-inset-bottom">
  <div class="container-fluid">

    <!-- Profile Summary (always visible) -->
    <div class="profile-summary-section">
      <div class="card profile-card">
        <div class="card-body">
          <div class="profile-header">
            <div class="profile-avatar">
              <app-avatar-picker
                [currentAvatar]="avatarConfig"
                (avatarChanged)="onAvatarChanged($event)"
              ></app-avatar-picker>
            </div>
            <div class="profile-info">
              <h2 class="profile-name">{{ userProfile.firstName }} {{ userProfile.lastName }}</h2>
              <p class="profile-email">{{ userProfile.email }}</p>
              <div class="profile-badges">
                <span class="level-badge">{{ userScore.levelName }}</span>
                <span class="verification-badge" [class]="getVerificationLevelClass(verificationStatus.verificationLevel)">
                  {{ verificationStatus.verificationLevel | titlecase }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section: Datos (Personal Info) -->
    <div *ngIf="activeSection === 'datos'" class="personal-info-section">
      <div class="card info-card">
        <div class="card-body">
          <div class="section-header-row">
            <h3 class="section-title">Informacion Personal</h3>
            <button *ngIf="!editMode" (click)="toggleEditMode()" class="btn btn-primary btn-sm">Editar</button>
            <button *ngIf="editMode" (click)="toggleEditMode()" class="btn btn-secondary btn-sm">Cancelar</button>
          </div>

          <div *ngIf="!editMode" class="info-display">
            <!-- Loading state -->
            <div *ngIf="!profileLoaded" class="info-loading">
              <span class="loading-placeholder">Cargando datos del perfil...</span>
            </div>

            <!-- Profile data -->
            <div *ngIf="profileLoaded" class="info-grid">
              <div class="info-item">
                <label>Nombre</label>
                <span>{{ userProfile.firstName || '-' }}</span>
              </div>
              <div class="info-item">
                <label>Apellido</label>
                <span>{{ userProfile.lastName || '-' }}</span>
              </div>
              <div class="info-item" [class.missing]="isFieldMissing('phone')">
                <label>Telefono <span *ngIf="isFieldMissing('phone')" class="required-tag">Necesario</span></label>
                <span *ngIf="!isFieldMissing('phone')">{{ userProfile.phone }}</span>
              </div>
              <div class="info-item" [class.missing]="isFieldMissing('dateOfBirth')">
                <label>Fecha de Nacimiento <span *ngIf="isFieldMissing('dateOfBirth')" class="required-tag">Necesario</span></label>
                <span *ngIf="!isFieldMissing('dateOfBirth')">{{ userProfile.dateOfBirth }}</span>
              </div>
              <div class="info-item" [class.missing]="isFieldMissing('address')">
                <label>Direccion <span *ngIf="isFieldMissing('address')" class="required-tag">Necesario</span></label>
                <span *ngIf="!isFieldMissing('address')">{{ userProfile.address?.street }}, {{ userProfile.address?.city }}</span>
              </div>
              <div class="info-item">
                <label>Miembro desde</label>
                <span>{{ userProfile.joinedDate | date:'dd/MM/yyyy' }}</span>
              </div>
            </div>
          </div>

          <form *ngIf="editMode" [formGroup]="profileForm" (ngSubmit)="onSaveProfile()" class="edit-form">
            <div class="form-grid">
              <div class="form-group">
                <label for="firstName">Nombre *</label>
                <input type="text" id="firstName" formControlName="firstName" class="form-control"
                  [class.is-invalid]="profileForm.get('firstName')?.invalid && profileForm.get('firstName')?.touched">
              </div>
              <div class="form-group">
                <label for="lastName">Apellido *</label>
                <input type="text" id="lastName" formControlName="lastName" class="form-control"
                  [class.is-invalid]="profileForm.get('lastName')?.invalid && profileForm.get('lastName')?.touched">
              </div>
              <div class="form-group">
                <label for="phone">Telefono *</label>
                <input type="tel" id="phone" formControlName="phone" class="form-control"
                  [class.is-invalid]="profileForm.get('phone')?.invalid && profileForm.get('phone')?.touched">
              </div>
              <div class="form-group">
                <label for="dateOfBirth">Fecha de Nacimiento *</label>
                <input type="date" id="dateOfBirth" formControlName="dateOfBirth" class="form-control"
                  [class.is-invalid]="profileForm.get('dateOfBirth')?.invalid && profileForm.get('dateOfBirth')?.touched">
              </div>
              <div class="form-group">
                <label for="street">Direccion *</label>
                <input type="text" id="street" formControlName="street" class="form-control" placeholder="Calle, numero"
                  [class.is-invalid]="profileForm.get('street')?.invalid && profileForm.get('street')?.touched">
              </div>
              <div class="form-group">
                <label for="city">Ciudad *</label>
                <input type="text" id="city" formControlName="city" class="form-control"
                  [class.is-invalid]="profileForm.get('city')?.invalid && profileForm.get('city')?.touched">
              </div>
              <div class="form-group">
                <label for="postalCode">Codigo Postal</label>
                <input type="text" id="postalCode" formControlName="postalCode" class="form-control">
              </div>
              <div class="form-group">
                <label for="country">Pais</label>
                <input type="text" id="country" formControlName="country" class="form-control">
              </div>
            </div>
            <div class="form-actions">
              <button type="submit" class="btn btn-primary" [disabled]="profileForm.invalid || saving">
                <span *ngIf="!saving">Guardar Cambios</span>
                <span *ngIf="saving">Guardando...</span>
              </button>
            </div>
          </form>

          <div class="logout-section">
            <button class="btn-logout" (click)="onLogout()">
              <span class="logout-icon">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                  <polyline points="16 17 21 12 16 7"/>
                  <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
              </span>
              Cerrar sesion
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Section: Nivel (Reputacion) -->
    <div *ngIf="activeSection === 'nivel'" class="level-section">
      <div class="card reputation-card">
        <div class="card-body">
          <h3 class="section-title">Reputacion</h3>
          <div class="reputation-score-container">
            <div class="reputation-circle" [style.border-color]="reputationScore.color">
              <span class="reputation-value" [style.color]="reputationScore.color">{{ reputationScore.score }}</span>
              <span class="reputation-max">/100</span>
            </div>
            <div class="reputation-info">
              <span class="reputation-level-label" [style.color]="reputationScore.color">{{ getReputationLevelLabel() }}</span>
              <span class="reputation-events">{{ reputationScore.events_count }} evento{{ reputationScore.events_count !== 1 ? 's' : '' }}</span>
            </div>
          </div>

          <!-- Recent events -->
          <div *ngIf="reputationHistory.length > 0" class="reputation-history">
            <h4 class="reputation-history-title">Ultimos eventos</h4>
            <div *ngFor="let event of reputationHistory" class="reputation-event-item">
              <span class="event-icon" [class.positive]="event.points_change > 0" [class.negative]="event.points_change < 0">
                {{ event.points_change > 0 ? '+' : '' }}{{ event.points_change }}
              </span>
              <span class="event-desc">{{ event.description }}</span>
              <span class="event-date">{{ event.created_at | date:'dd/MM' }}</span>
            </div>
          </div>
          <div *ngIf="reputationHistory.length === 0 && !reputationLoading" class="empty-state">
            Sin eventos de reputacion aun. Completa pedidos y reservas para mejorar tu puntuacion.
          </div>
        </div>
      </div>
    </div>

    <!-- Section: Verificar -->
    <div *ngIf="activeSection === 'verificar'" class="verification-section">
      <div class="card verification-card">
        <div class="card-body">
          <div class="verification-header">
            <h3 class="section-title">Estado de Verificacion</h3>
            <div class="verification-counter" [class]="getTrustScoreClass(verificationStatus.trustScore)">
              <span class="counter-value">{{ getVerifiedCount() }}/3</span>
              <span class="counter-label">verificados</span>
            </div>
          </div>
          <div class="verification-list">
            <div class="verification-item">
              <div class="verification-info">
                <span class="verification-icon">📧</span>
                <span class="verification-text">Email verificado</span>
              </div>
              <div class="verification-status">
                <span *ngIf="verificationStatus.emailVerified" class="status-verified">Verificado</span>
                <button *ngIf="!verificationStatus.emailVerified" (click)="onVerifyEmail()" class="btn btn-sm btn-outline-primary">Verificar</button>
              </div>
            </div>
            <div class="verification-item">
              <div class="verification-info">
                <span class="verification-icon">🆔</span>
                <span class="verification-text">Identidad verificada</span>
              </div>
              <div class="verification-status">
                <span *ngIf="verificationStatus.identityVerified" class="status-verified">Verificado</span>
                <button *ngIf="!verificationStatus.identityVerified" (click)="onVerifyIdentity()" class="btn btn-sm btn-outline-primary">Verificar</button>
              </div>
            </div>
            <div class="verification-item disabled">
              <div class="verification-info">
                <span class="verification-icon">🏠</span>
                <span class="verification-text">Direccion verificada</span>
              </div>
              <div class="verification-status">
                <span *ngIf="verificationStatus.addressVerified" class="status-verified">Verificado</span>
                <span *ngIf="!verificationStatus.addressVerified" class="status-hint">Se verifica con tu primer pedido</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section: Ajustes -->
    <div *ngIf="activeSection === 'ajustes'" class="account-settings-section">

      <!-- Notificaciones -->
      <div class="card settings-card">
        <div class="card-body">
          <h3 class="section-title">Notificaciones</h3>

          <!-- Estado actual -->
          <div class="notif-status-row">
            <span class="notif-status-label">Estado</span>
            <span class="notif-status-badge"
              [class.granted]="notifPermission === 'granted'"
              [class.denied]="notifPermission === 'denied'"
              [class.default-perm]="notifPermission === 'default'"
              [class.unavailable]="notifPermission === 'unavailable'">
              <ng-container [ngSwitch]="notifPermission">
                <ng-container *ngSwitchCase="'granted'">Activadas</ng-container>
                <ng-container *ngSwitchCase="'denied'">Bloqueadas</ng-container>
                <ng-container *ngSwitchCase="'default'">Sin configurar</ng-container>
                <ng-container *ngSwitchCase="'unavailable'">No disponible</ng-container>
              </ng-container>
            </span>
          </div>

          <!-- Info plataforma -->
          <div class="notif-info-grid">
            <div class="notif-info-item">
              <span class="notif-info-label">Service Worker</span>
              <span class="notif-info-value" [class.active]="hasSW">{{ hasSW ? 'Activo' : 'Inactivo' }}</span>
            </div>
            <div class="notif-info-item">
              <span class="notif-info-label">Modo instalado</span>
              <span class="notif-info-value" [class.active]="isStandalone">{{ isStandalone ? 'Si' : 'No' }}</span>
            </div>
            <div class="notif-info-item" *ngIf="isIos">
              <span class="notif-info-label">Plataforma</span>
              <span class="notif-info-value">iOS</span>
            </div>
          </div>

          <!-- Mensaje iOS sin instalar -->
          <div *ngIf="isIos && !isStandalone" class="notif-ios-warning">
            <span class="notif-ios-icon">&#9888;&#65039;</span>
            <div class="notif-ios-text">
              <strong>Las notificaciones en iOS solo funcionan si la app esta instalada en la pantalla de inicio.</strong>
              <button class="btn-ios-guide" (click)="showIosInstallModal = true">Ver como instalar</button>
            </div>
          </div>

          <!-- Acciones -->
          <div class="notif-actions">
            <button
              *ngIf="notifPermission === 'default' || (isIos && !isStandalone)"
              class="setting-item"
              (click)="requestNotifPermission()">
              <span class="setting-icon">&#128276;</span>
              <span class="setting-text">Activar notificaciones</span>
              <span class="setting-arrow">></span>
            </button>

            <button
              *ngIf="notifPermission === 'granted'"
              class="setting-item"
              (click)="sendTestNotification()">
              <span class="setting-icon">&#128172;</span>
              <span class="setting-text">Enviar notificacion de prueba</span>
              <span class="setting-arrow">></span>
            </button>

            <button
              class="setting-item"
              (click)="refreshNotifStatus()">
              <span class="setting-icon">&#128260;</span>
              <span class="setting-text">Actualizar estado</span>
              <span class="setting-arrow">></span>
            </button>
          </div>

          <!-- Mensaje denied -->
          <div *ngIf="notifPermission === 'denied'" class="notif-denied-info">
            Las notificaciones estan bloqueadas. Para activarlas, abre la configuracion de tu navegador y permite las notificaciones para este sitio.
          </div>

          <!-- Feedback de test -->
          <div *ngIf="notifTestSent" class="notif-test-result" [class.success]="notifTestMessage.includes('enviada')">
            {{ notifTestMessage }}
          </div>
        </div>
      </div>

      <!-- Cuenta -->
      <div class="card settings-card">
        <div class="card-body">
          <h3 class="section-title">Cuenta</h3>
          <div class="settings-list">
            <button (click)="onChangePassword()" class="setting-item">
              <span class="setting-icon">&#128274;</span>
              <span class="setting-text">Cambiar contrasena</span>
              <span class="setting-arrow">></span>
            </button>
            <button (click)="onDeleteAccount()" class="setting-item danger">
              <span class="setting-icon">&#128465;&#65039;</span>
              <span class="setting-text">Eliminar cuenta</span>
              <span class="setting-arrow">></span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- iOS Install Modal -->
    <div *ngIf="showIosInstallModal" class="ios-modal-overlay" (click)="closeIosModal()">
      <div class="ios-modal" (click)="$event.stopPropagation()">
        <div class="ios-modal-header">
          <h3>Instalar BarClik en iOS</h3>
          <button class="ios-modal-close" (click)="closeIosModal()">&times;</button>
        </div>
        <div class="ios-modal-body">
          <p class="ios-modal-intro">
            Para recibir notificaciones de tus pedidos en iPhone/iPad, necesitas instalar la app en tu pantalla de inicio.
          </p>
          <ol class="ios-steps">
            <li>
              <div class="ios-step-content">
                <strong>Toca el boton Compartir</strong>
                <span class="ios-step-desc">Es el icono con una flecha hacia arriba <span class="ios-share-icon">&#9757;</span> en la barra inferior de Safari</span>
              </div>
            </li>
            <li>
              <div class="ios-step-content">
                <strong>Desplazate y toca "Anadir a pantalla de inicio"</strong>
                <span class="ios-step-desc">Busca la opcion con el icono <strong>+</strong> en el menu</span>
              </div>
            </li>
            <li>
              <div class="ios-step-content">
                <strong>Pulsa "Anadir"</strong>
                <span class="ios-step-desc">Se creara un icono de BarClik en tu pantalla</span>
              </div>
            </li>
            <li>
              <div class="ios-step-content">
                <strong>Abre BarClik desde el icono</strong>
                <span class="ios-step-desc">La app se abrira sin barra de Safari, como una app nativa</span>
              </div>
            </li>
            <li>
              <div class="ios-step-content">
                <strong>Acepta las notificaciones</strong>
                <span class="ios-step-desc">Al abrir desde el icono, iOS te preguntara si quieres permitir notificaciones. Pulsa "Permitir"</span>
              </div>
            </li>
          </ol>
          <div class="ios-modal-note">
            <strong>Requisitos:</strong> iOS 16.4 o superior y Safari como navegador.
          </div>
        </div>
        <div class="ios-modal-footer">
          <button class="btn-ios-close" (click)="closeIosModal()">Entendido</button>
        </div>
      </div>
    </div>

    <!-- Section: App (PWA) -->
    <div *ngIf="activeSection === 'app'" class="pwa-installation-section">
      <div class="card">
        <div class="card-body">
          <h3 class="section-title">Instalacion de App</h3>
          <app-pwa-install-section></app-pwa-install-section>
        </div>
      </div>
    </div>

  </div>
</div>
